import React from 'react';
import { StyleSheet, css } from 'aphrodite';

// MATERIAL


export default class SkewBg extends React.Component{

  render(){
    return(
        <div className={css(styles.mainContainer)}>
            <section className={css(styles.skewIntro)}>
            </section>
        </div>
    )
  }
}

const styles = StyleSheet.create({
    mainContainer : {
        position: 'relative',
    },
    skewIntro: {
        position: 'absolute',
        zIndex: -1,
        top: 0,
        width: '100vw',
        height: 1000,
        overflow: 'hidden',
        transform: 'skewY(12deg)',
        transformOrigin: 0,
        background: 'linear-gradient(-69deg, #FF6B4D, #D85944)',
       '@media (max-width: 768px)' :{
            textAlign: 'center',
            paddingTop: '8em',
            height: 1500,
       }
    },
});


// WEBPACK FOOTER //
// ./src/Components/Portfolio/BlockChain/SkewBg.js